import _extends from "@babel/runtime/helpers/esm/extends";
var _g, _defs;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgDoordash = function SvgDoordash(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_g || (_g = /*#__PURE__*/_jsx("g", {
      clipPath: "url(#doordash_svg__a)",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M35.48-.48H-.48v35.96h35.96V-.48ZM18.8 23.49h3.345c4.348 0 7.637-4.589 5.208-9.144a5.428 5.428 0 0 0-4.803-2.836H7.34a.521.521 0 0 0-.48.32.521.521 0 0 0-.037.147.528.528 0 0 0 .15.414l3.313 3.29c.292.291.69.454 1.105.454h10.724a1.372 1.372 0 0 1 1.395 1.35 1.375 1.375 0 0 1-1.368 1.38h-7.394a.481.481 0 0 0-.15.024.508.508 0 0 0-.33.297.495.495 0 0 0 .022.439.506.506 0 0 0 .091.122l3.314 3.29c.074.074.153.138.239.194.084.055.175.106.27.143a1.482 1.482 0 0 0 .597.117Z",
        fill: "currentColor"
      })
    })), _defs || (_defs = /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "doordash_svg__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h35v35H0z"
        })
      })
    }))]
  }));
};
export default SvgDoordash;